import axios from "../../../utils/axios";
import { handleError } from "../../../utils/common-utils";


export const performCODTransaction = ({
  requestDetails,
  onSuccess,
  onFailure,
}) => {
  axios
    .post("/payments/cod/", { ...requestDetails })
    .then(({ data }) => {
      onSuccess(data.id);
    })
    .catch((error) => {
      const message = handleError(error);
      onFailure(message);
    });
};
